/* eslint-disable no-duplicate-imports */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICwsProductFeaturesData } from './cws-product-features.data';
import { ICwsProductFeaturesProps } from './cws-product-features.props.autogenerated';
import { observer } from 'mobx-react';
import { ICoreContext } from '@msdyn365-commerce/core';

export interface ICwsProductFeaturesViewProps extends ICwsProductFeaturesProps<ICwsProductFeaturesData> {
    context: ICoreContext;
}

/**
 *
 * CwsProductFeatures component
 * @extends {React.Component<ICwsProductFeaturesProps<ICwsProductFeaturesData>>}
 */
@observer
class CwsProductFeatures extends React.Component<ICwsProductFeaturesViewProps> {
    public render(): JSX.Element | null {
        const { data } = this.props;
        const product = data?.product?.result;

        if (!product) {
            return null;
        }

        const extensionProps = product.ExtensionProperties || [];
        const featureProp = extensionProps.find(p => p.Key === 'ProductFeatures');

        return this.props.renderView({
            ...this.props,
            extensionProps: featureProp ? [featureProp] : []
        });
    }
}

export default CwsProductFeatures;
